import { render, staticRenderFns } from "./UploadComplete.vue?vue&type=template&id=67cea1ce"
import script from "./UploadComplete.vue?vue&type=script&lang=ts"
export * from "./UploadComplete.vue?vue&type=script&lang=ts"
import style0 from "./UploadComplete.vue?vue&type=style&index=0&id=67cea1ce&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports